<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderPromocodes',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'promocodes', text: 'Promo codes', to: AppRoute.Promocodes, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
